var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M27.4668 5.46647V8.39981C27.4668 9.46647 26.8001 10.7998 26.1335 11.4665L20.4001 16.5331C19.6001 17.1998 19.0668 18.5331 19.0668 19.5998V25.3331C19.0668 26.1331 18.5335 27.1998 17.8668 27.5998L16.0001 28.7998C14.2668 29.8665 11.8668 28.6665 11.8668 26.5331V19.4665C11.8668 18.5331 11.3335 17.3331 10.8001 16.6665L9.4668 15.2665L17.2268 2.7998H24.8001C26.2668 2.7998 27.4668 3.9998 27.4668 5.46647Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0665 2.7998L8.15987 13.8798L5.7332 11.3331C5.06654 10.6665 4.5332 9.46647 4.5332 8.66647V5.5998C4.5332 3.9998 5.7332 2.7998 7.19987 2.7998H15.0665Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9ff248d777c010490dc8a3d5c8a96b12.svg";
export { ForwardRef as ReactComponent };